import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useAccountPreferencesSubverticalSettingsMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (account: Api.IAccount) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (params: {
			subvSettings: Api.ISubverticalSettings;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IAccount>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `Account/preferences/subverticalSettings`,
					impersonationContext: params.impersonationContext,
				}),
				'PUT',
				params.subvSettings
			);
		},
		onError,
		onSuccess,
	});
}
